import { Overlay } from './Overlay';
import { NgModule } from '@angular/core';
//import { HttpProvider } from "./factory.http";

let COMPONENTS = [
   Overlay
];

@NgModule({
    imports: [],
    declarations: COMPONENTS,
    exports: COMPONENTS,
    providers: [],
})
export class SharedResourcesModule { }
